import { showUserAlert } from "../utils/userErrorMessage";
import React, { useState, useEffect } from "react";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import { supabase } from "../supabase/client";
import Header from "../Component/Header";
import { useNavigate } from "react-router-dom";

export default function HolidayInfo() {
  const [holidays, setHolidays] = useState([]);
  const [selectedHoliday, setSelectedHoliday] = useState(null);
  const [selectedIds, setSelectedIds] = useState(new Set());
  const [deletingSelected, setDeletingSelected] = useState(false);
  const [form, setForm] = useState({ date: "", name: "" });
  const navigate = useNavigate();

  const fetchHolidays = async () => {
    const company = localStorage.getItem("email");
    const { data, error } = await supabase
    .from("holidays")
    .select("*")
    .eq("company", company)
    .order("date", { ascending: true }); // ✅ 날짜 순 정렬

    if (!error) {
      setHolidays(data || []);
      setSelectedIds(new Set());
    }
  };

  useEffect(() => {
    fetchHolidays();
  }, []);

  const handleSelect = (holiday) => {
  setSelectedHoliday(holiday);
  setForm({ id: holiday.id, date: holiday.date, name: holiday.name }); // ✅ id 포함
};

const handleChange = (field, value) => {
  setForm({ ...form, [field]: value });
};

const handleUpdate = async () => {
  const { id, date, name } = form;
  const company = localStorage.getItem("email");
  const { error } = await supabase.from("holidays")
    .update({ date: date, name: name }) // ✅ 필드 이름 주의
    .eq("id", id)
    .eq("company", company); // ✅ date가 아닌 id 기준
    

  if (!error) {
    showUserAlert("수정 완료");
    setSelectedHoliday(null);
    fetchHolidays();
  }
};

const toggleHolidaySelection = (id) => {
  setSelectedIds((prev) => {
    const next = new Set(prev);
    if (next.has(id)) next.delete(id);
    else next.add(id);
    return next;
  });
};

const handleDeleteSelected = async () => {
  if (deletingSelected || selectedIds.size === 0) return;

  const selectedCount = selectedIds.size;
  const ok = window.confirm(`${selectedCount}개의 휴일 정보를 삭제하시겠습니까?`);
  if (!ok) return;

  setDeletingSelected(true);
  const { error } = await supabase
    .from("holidays")
    .delete()
    .eq("company", localStorage.getItem("email"))
    .in("id", Array.from(selectedIds));
  setDeletingSelected(false);

  if (error) {
    showUserAlert("삭제 실패: " + error.message);
    return;
  }

  showUserAlert("삭제 완료");
  setSelectedHoliday(null);
  fetchHolidays();
};


  const handleDelete = async () => {
    const company = localStorage.getItem("email");
    const { error } = await supabase
      .from("holidays")
      .delete()
      .eq("date", form.date)
      .eq("company", company);

    if (!error) {
      showUserAlert("삭제 완료");
      setSelectedHoliday(null);
      fetchHolidays();
    }
  };

  return (
    <div className="space-y-1">
      <Header />
      <div className="px-4 pt-1 pb-4">
      <h2 className="text-lg font-semibold">휴일 정보</h2>

      <Card>
        <CardContent className="bg-white">
          <table className="table-fixed w-full border border-gray-300 text-sm">
            <colgroup>
              <col className="w-12" />
              <col className="w-[104px]" />
              <col />
            </colgroup>
            <thead className="bg-blue-500 text-white">
              <tr>
                <th className="border p-2 w-12">선택</th>
                <th className="border p-2 whitespace-nowrap">휴일</th>
                <th className="border p-2">휴일명</th>
              </tr>
            </thead>
            <tbody>
              {holidays.map((holiday) => (
                <tr
                  key={holiday.id || holiday.date}
                  onClick={() => handleSelect(holiday)}
                >
                  <td className="border p-2 text-center" onClick={(event) => event.stopPropagation()}>
                    <input
                      type="checkbox"
                      checked={selectedIds.has(holiday.id)}
                      onChange={() => toggleHolidaySelection(holiday.id)}
                      aria-label={`${holiday.date} 휴일 선택`}
                    />
                  </td>
                  <td className="border p-2 text-center whitespace-nowrap">{holiday.date}</td>
                  <td className="border p-2">{holiday.name}</td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* ✅ 추가 등록 버튼 */}
          <div className="mt-4 flex justify-end gap-2">
            <Button
              variant="destructive"
              onClick={handleDeleteSelected}
              disabled={selectedIds.size === 0 || deletingSelected}
            >
              {deletingSelected ? "삭제 중..." : "삭제"}
            </Button>
            <Button onClick={() => navigate("/holiday-add")}>추가 등록</Button>
          </div>
        </CardContent>
      </Card>
      </div>

      {selectedHoliday && (
        <div className="px-4 pb-4">
          <Card>
            <CardContent className="bg-white">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="font-semibold mb-1 block">휴일</label>
                  <Input value={form.date} onChange={(e) => handleChange("date", e.target.value)} />
                </div>
                <div>
                  <label className="font-semibold mb-1 block">휴일명</label>
                  <Input value={form.name} onChange={(e) => handleChange("name", e.target.value)} />
                </div>
                <div className="md:col-span-2 flex gap-4 mt-4">
                  <Button onClick={handleUpdate}>수정</Button>
                  <Button onClick={handleDelete} variant="destructive">
                    삭제
                  </Button>
                  <Button variant="outline" onClick={() => setSelectedHoliday(null)}>
                    돌아가기
                  </Button>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      )}
    </div>
  );
  
}
